/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Partner_Billing_Board_Counts_ReportsInputs */



/**
* | output |
* | --- |
* | "{count} reports in this month" |
*
* @param {Partner_Billing_Board_Counts_ReportsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_counts_reports = /** @type {((inputs: Partner_Billing_Board_Counts_ReportsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Counts_ReportsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Berichte in diesem Monat`)
	return /** @type {LocalizedString} */ (`${i?.count} reports in this month`)
});